import { connect } from 'react-redux';
import PopupActMVP from './PopupActMVP';
import {
  popupActClose,
  dopPopupClose,
  getPopupActReport,
  getPopupActErrorClose,
  popupActGetNote,
  popupActAddNote,
  popupSetNewFormed
} from '../../store/actions/popupAct';
import { modalErrorOpen } from '../../store/actions/modalError';

import { getAdminActUpdate } from '../../store/actions/documents';
import { getIncomingUpdate } from '../../store/actions/incoming';
import { getShipmentUpdate, getShipmentClear } from '../../store/actions/shipment';
import { getTnListUpdate } from '../../store/actions/tn';

const mapStateToProps = ({
  popupActReducer,
  userReducer
}) => ({
  popupActReducer,
  userReducer
});
const mapDispatchToProps = {
  popupActClose,
  dopPopupClose,
  getPopupActReport,
  getPopupActErrorClose,
  popupActGetNote,
  popupActAddNote,
  popupSetNewFormed,
  getAdminActUpdate,
  getIncomingUpdate,
  getShipmentUpdate,
  modalErrorOpen,
  getShipmentClear,
  getTnListUpdate
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupActMVP);
